<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Reklamation / Returorder'" :sub-title="returnorder_name" :title-id="returnorder_id">
            <template #header-elements>
                <limitless-page-header-button url="/returnorders" icon="icon-circle-left2">Till Listan</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content" v-if="!initialized && busy_loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div class="content" v-else-if="!not_found && returnorder">
            <div v-if="returnorder.ReturnOrderID > 0 && returnorder.StatusID === 0" class="alert alert-warning" style="font-size: 24px; font-weight: 500;">
                Kontrollera informationen och klicka på spara för att slutföra registreringen
            </div>
            <div v-else-if="returnorder.ReturnOrderID > 0">
                <div class="alert" :class="[ 'alert-' + returnorder.status.Class ]">
                    <div class="row">
                        <div class="col-auto flex-shrink-1">
                            <span class="font-weight-semibold">Status: {{ returnorder.status.StatusID }} - {{ returnorder.status.Status }}</span>
                        </div>
                        <div class="col-auto text-center flex-grow-1" style="margin: -8px 0;">
                            <div v-if="returnorder.StatusID === 55">
                                <button type="button" class="btn btn-success" @click="changeStatus(80)">
                                    SÄTT STATUS TILL OMLEVERANS
                                </button>
                                <button type="button" class="btn btn-warning" @click="changeStatus(600)">
                                    STÄNG pga saknad återkoppling från kund
                                </button>
                            </div>
                        </div>
                        <div class="col-auto text-right flex-shrink-1" style="margin: -8px 0;">
                            <div class="btn-group position-static">
                                <button type="button" class="btn dropdown-toggle mr-2" :class="[ 'btn-outline-' + returnorder.status.Class ]" data-toggle="dropdown" aria-expanded="false">
                                    ÄNDRA STATUS
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a
                                        v-for="status in allowed_status_change"
                                        :key="'a-status-change-' + status.id"
                                        href="#"
                                        class="dropdown-item"
                                        @click.prevent="changeStatus(status.id)"
                                    >
                                        {{ status.name }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <ValidationObserver ref="returnorderform" v-slot="{ dirty }">
                        <form @submit.prevent="saveReturnOrder">
                            <div v-if="prod_order_id > 0 && id == 0" class="card">
                                <div class="card-header header-elements-inline bg-light">
                                    <h5 class="card-title">
                                        {{ returnorder_name }} #{{ returnorder.CardNo }}
                                    </h5>
                                </div>
                                <div class="card-body">
                                    <div class="row" v-if="prodorder">
                                        <div class="col-lg-12">
                                            <ValidationProvider
                                                vid="product_ids"
                                                name="Produkt"
                                                rules="required"
                                                v-slot="{ errors }"
                                            >
                                                <div class="form-group">
                                                    <label class="font-weight-semibold">Vilken produkt reklameras?</label>
                                                    <div
                                                        v-for="(prod, p_index) in prodorder.items"
                                                        class="custom-control custom-checkbox mb-2"
                                                        :key="'p-' + prod.ProdOrderItemID + '-' + p_index"
                                                    >
                                                        <input type="checkbox" class="custom-control-input" name="prod_id" :id="'p-' + prod.ProdOrderItemID + '-' + p_index" v-model="returnorder.product_ids" :value="prod.product.ProdID">
                                                        <label class="custom-control-label" :for="'p-' + prod.ProdOrderItemID + '-' + p_index">#{{ prod.product.ProdID }} - {{ prod.product.ProdName}}</label>
                                                    </div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="font-weight-semibold mb-2">Anledning till sändning av ny produkt</div>
                                            <ValidationProvider vid="ResendReason" name="Anledning till sändning av ny produkt" rules="required" v-slot="{ errors }">
                                                <div class="custom-control custom-radio mb-2" v-for="rs in select_resend_reasons" :key="'rs-' + rs.id">
                                                    <input type="radio" class="custom-control-input" name="ResendReason" :id="'rs-' + rs.id" :value="rs.id" v-model="returnorder.ResendReason">
                                                    <label class="custom-control-label" :for="'rs-' + rs.id">{{ rs.label }}</label>
                                                </div>
                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="font-weight-semibold mb-2">Vem berodde felet på</div>
                                            <ValidationProvider vid="ResendReasonBy" name="Vem berodde felet på" rules="required" v-slot="{ errors }">
                                                <div class="custom-control custom-radio mb-2" v-for="rsb in select_resend_reason_by" :key="'rsb-' + rsb.id">
                                                    <input type="radio" class="custom-control-input" name="ResendReasonBy" :id="'rsb-' + rsb.id" :value="rsb.id" v-model="returnorder.ResendReasonBy">
                                                    <label class="custom-control-label" :for="'rsb-' + rsb.id">{{ rsb.label }}</label>
                                                </div>
                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="font-weight-semibold mb-2">Omleverans / Retur</div>
                                            <ValidationProvider vid="RequestReturn" name="Omleverans / Retur" rules="required" v-slot="{ errors }">
                                                <div class="custom-control custom-radio mb-2" v-for="rr in select_request_return" :key="'rr-' + rr.id">
                                                    <input type="radio" class="custom-control-input" name="RequestReturn" :id="'rr-' + rr.id" :value="rr.id" v-model="returnorder.RequestReturn">
                                                    <label class="custom-control-label" :for="'rr-' + rr.id">{{ rr.label }}</label>
                                                </div>
                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="d-flex justify-content-end">
                                        <limitless-button ref="btnsavereturnorder" type="button" @click="saveReturnOrder" :busy="busy_saving" icon="icon-floppy-disk">Spara</limitless-button>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="card">
                                <div class="card-header header-elements-inline bg-light">
                                    <h5 class="card-title">
                                        <i class="icon-user mr-2"></i>Kundinformation
                                        <div class="badge ml-3" :class="['badge-' + returnorder.status.Class]">{{ returnorder.status.Status }}</div>
                                    </h5>
                                    <div class="header-elements">
                                        <limitless-button v-if="returnorder.StatusID > 0 && returnorder.StatusID < 900" @click="markAsDone" btn-class="btn-success" icon="icon-finish">Avsluta</limitless-button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <input-with-validation v-model="returnorder.Name" label="Namn" rules="required" vid="Name" compact />
                                            <input-with-validation v-model="returnorder.Company" label="Företag" vid="Company" compact />
                                            <input-with-validation v-model="returnorder.Street" label="Gatuadress" :rules="{ required: returnorder.DeliveryType !== 'online' }" vid="Street" compact />
                                            <div class="row">
                                                <div class="col-lg-4">
                                                    <input-with-validation v-model="returnorder.Zip" label="Postnummer" :rules="{ required: returnorder.DeliveryType !== 'online' }" vid="Zip" compact />
                                                </div>
                                                <div class="col-lg-8">
                                                    <input-with-validation v-model="returnorder.City" label="Postort" :rules="{ required: returnorder.DeliveryType !== 'online' }" vid="City" compact />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4">
                                                    <select-with-validation
                                                        component="country-filter"
                                                        v-model="returnorder.CountryCode"
                                                        :reduce="(opt) => opt.id"
                                                        label="Land"
                                                        rules="required"
                                                        vid="CountryCode"
                                                        compact
                                                        :clearable="false"
                                                    />
                                                </div>
                                                <div class="col-lg-4"></div>
                                                <div class="col-lg-4">
                                                    <input-with-validation v-model="returnorder.DoorAccessCode" label="Portkod" vid="DoorAccessCode" compact />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div v-if="returnorder.ReturnOrderID > 0" class="form-group mb-2">
                                                <label style="margin-bottom: 4px;">Kortnummer</label>
                                                <div class="input-group">
                                                    <input type="text" class="form-control" :value="returnorder.CardNo" disabled>
                                                    <div class="input-group-append">
                                                        <router-link :to="{ name: 'prodorders.list', query: { search: returnorder.CardNo } }" class="btn btn-light">Visa ursprungsbeställning</router-link>
                                                    </div>
                                                </div>
                                            </div>
                                            <input-with-validation v-else v-model="returnorder.CardNo" label="Kortnummer" vid="CardNo" compact readonly />
                                            <input-with-validation v-model="returnorder.Phone" label="Telefon" :rules="{ required: !(returnorder.Email) }" vid="Phone" compact />
                                            <input-with-validation v-model="returnorder.Email" label="E-postadress" :rules="{ required: !(returnorder.Phone) }" vid="Email" compact />
                                            <div style='margin-top: 15px;'>
                                                <div>Kolla: <img :src="old_system_url + '/img/posten_se.gif'"></div>
                                                <div class="ml-2">
                                                    <a href="#" @click.prevent="winOpen('/postnord/postnummer/' + returnorder.Street + ',' + returnorder.City)" target="SHT_InfoPop">- Postnummer</a><br>
                                                    <a href="#" @click.prevent="winOpen('/postnord/deliverytime/' + returnorder.CountryCode + '/' + returnorder.Zip.replaceAll(' ', ''))" target="SHT_InfoPop">- Leveranstid</a><br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="returnorder.ReturnOrderID > 0" class="card-header header-elements-inline bg-light border-top">
                                    <h5 class="card-title"><i class="icon-images2 mr-2"></i>Bilder/ Video / Filer</h5>
                                    <div class="header-elements">
                                        <limitless-button @click="showUploadModal" btn-class="btn-light" icon="icon-cloud-upload" :disabled="!(returnorder.ReturnOrderID > 0)">Ladda upp</limitless-button>
                                    </div>
                                </div>
                                <div v-if="returnorder.ReturnOrderID > 0" class="card-body">
                                    <div v-if="images.length > 0"
                                         class="file-grid"
                                    >
                                        <div v-for="(image, i_index) in images"
                                             :key="'i-' + i_index"
                                        >
                                            <div class="card mb-0" >
                                                <div class="card-body p-1">
                                                    <div class="image-wrapper"
                                                         :style="{ 'background-image': 'url(' + image.url_preview + ')' }"
                                                         @click="showFullImage(image.url_show ? image.url_show : image.url_download)" style="cursor: pointer;"
                                                    ></div>
                                                </div>
                                                <div class="p-1" style="overflow: hidden; max-width: 100%; text-overflow: ellipsis; word-break: break-word; text-align: center;">
                                                    {{ image.filename }}
                                                </div>
                                                <div class="card-footer d-flex p-0">
                                                    <div v-if="image.url_show" class="p-1 flex-grow-1">
                                                        <b-button variant="light" block @click="showFullImage(image.url_show)">Visa större</b-button>
                                                    </div>
                                                    <div v-else class="p-1 flex-grow-1">
                                                        <b-button variant="light" block @click="showFullImage(image.url_download)">Ladda ner</b-button>
                                                    </div>
                                                    <div class="p-1 flex-grow-1">
                                                        <b-button variant="danger" block @click="deleteImage(image.filename)">Radera</b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="returnorder.ReturnOrderID > 0" class="pb-3"><i>Inga bilder</i></div>
                                    <div v-else class="pb-3"><i>Spara först...</i></div>
                                </div>
                                <div class="card-header header-elements-inline bg-light border-top">
                                    <h5 class="card-title"><i class="icon-backward2 mr-2"></i>Reklamation / Åtgärd</h5>
                                </div>
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <ValidationProvider
                                                vid="product_ids"
                                                name="Produkt"
                                                rules="required"
                                                v-slot="{ errors }"
                                            >
                                                <div class="form-group">
                                                    <label>Reklamation av produkt</label>
                                                    <div
                                                        v-for="(prod, p_index) in prodorder.items"
                                                        class="custom-control custom-checkbox mb-2"
                                                        :key="'p-' + prod.ProdOrderItemID + '-' + p_index"
                                                    >
                                                        <input type="checkbox" class="custom-control-input" name="prod_id" :id="'p-' + prod.ProdOrderItemID + '-' + p_index" v-model="returnorder.product_ids" :value="prod.product.ProdID">
                                                        <label class="custom-control-label" :for="'p-' + prod.ProdOrderItemID + '-' + p_index">#{{ prod.product.ProdID }} - {{ prod.product.ProdName}}</label>
                                                    </div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <select-with-validation
                                                vid="ResendReason"
                                                label="Anledning till sändning av ny produkt"
                                                component="resend-reason-filter"
                                                v-model="returnorder.ResendReason"
                                                :reduce="(opt) => opt.id"
                                                rules="required"
                                                :clearable="false"
                                            ></select-with-validation>
                                        </div>
                                        <div class="col-lg-4">
                                            <select-with-validation
                                                vid="ResendReasonBy"
                                                label="Vem berodde felet på"
                                                component="resend-reason-by-filter"
                                                v-model="returnorder.ResendReasonBy"
                                                :reduce="(opt) => opt.id"
                                                rules="required"
                                                :clearable="false"
                                            ></select-with-validation>
                                        </div>
                                        <div class="col-lg-4">
                                            <select-with-validation
                                                vid="RequestReturn"
                                                label="Omleverans / Retur"
                                                component="request-return-filter"
                                                v-model="returnorder.RequestReturn"
                                                :reduce="(opt) => opt.id"
                                                rules="required"
                                                :clearable="false"
                                            ></select-with-validation>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <textarea-with-validation
                                            label="Beskrivning av fel/skada"
                                            vid="description"
                                            v-model="returnorder.description"
                                            :min-height="100"
                                        ></textarea-with-validation>
                                    </div>
                                    <div class="form-group">
                                        <textarea-with-validation
                                            label="Intern kommentar / Instruktion till lagret"
                                            vid="internal_comment"
                                            v-model="returnorder.internal_comment"
                                            :min-height="100"
                                        ></textarea-with-validation>
                                    </div>
                                </div>
                                <div class="card-header header-elements-inline bg-light border-top">
                                    <h5 class="card-title"><i class="icon-truck mr-2"></i>Leverans</h5>
                                    <div class="header-elements">
                                        <div v-if="returnorder.IsDeliverable" class="badge badge-success">Flaggad som levererbar</div>
                                        <div v-else class="badge badge-danger">Ej flaggad som levererbar</div>
                                    </div>
                                </div>
                                <div class="card-body pb-0">
                                    <div class="form-group row" v-if="returnorder.StatusID !== 510 && returnorder.DeliveryType !== 'online'">
                                        <label class="col-form-label col-lg-2">Önskat lev. datum</label>
                                        <ValidationProvider tag="div" class="col-lg-6" vid="DeliveryDate" name="Leveransdatum" rules="required" v-slot="{ errors }">
                                            <v-date-picker v-model="returnorder.WantedDeliveryDate" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                <template v-slot="{ inputValue, togglePopover }">
                                                    <div class="input-group">
                                                        <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                        <span class="input-group-append">
                                                            <button class="btn btn-light" type="button" @click="returnorder.WantedDeliveryDate = ''"><i class="icon-cross3"></i></button>
                                                        </span>
                                                    </div>
                                                </template>
                                            </v-date-picker>
                                            <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                        <div class="col-lg-4 col-form-label d-flex">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="chk-WantedDeliveryDateByCustomer" v-model="returnorder.WantedDeliveryDateByCustomer" :true-value="1" :false-value="0">
                                                <label class="custom-control-label" for="chk-WantedDeliveryDateByCustomer">Kundbokad leverans</label>
                                            </div>
                                            <span class="badge bg-teal text-uppercase text-white ml-auto" v-if="deliv_date_str" v-html="deliv_date_str"></span>
                                        </div>
                                    </div>
                                    <div class="form-group row" v-if="returnorder.StatusID !== 510">
                                        <label class="col-form-label col-lg-2">Fraktsätt</label>
                                        <select-with-validation
                                            vid="DeliveryType"
                                            class="col-lg-6 mb-0"
                                            v-model="returnorder.DeliveryType"
                                            :reduce="(opt) => opt.id"
                                            component="delivery-type-filter"
                                            rules="required"
                                            :clearable="false"
                                        ></select-with-validation>
                                        <div class="col-lg-4 col-form-label" v-if="returnorder.DeliveryType !== 'online'">
                                            <div v-html="delivery_info"></div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="returnorder.DeliveryType === 'postoffice'"
                                        class="form-group row"
                                    >
                                        <label class="col-form-label col-lg-2">Ombud</label>
                                        <div class="col-lg-6">
                                            <select-with-validation
                                                vid="service_point"
                                                label="Ombud"
                                                v-model="returnorder.service_point"
                                                :service-point="service_point"
                                                :criteria="service_point_criteria"
                                                component="service-point-filter"
                                                placeholder="Postnord väljer ombud"
                                                hide-label
                                            ></select-with-validation>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="table-responsive mb-0 border-bottom">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 100px;" class="px-1 py-2 text-center">SKU</th>
                                                        <th style="width: 38px;" class="px-1 py-2">
                                                            <div style="width: 38px; height: 2px; background-color: #fff;"></div>
                                                        </th>
                                                        <th class="px-1 py-2">Benämning</th>
                                                        <th style="width: 20px;" class="px-1 py-2"></th>
                                                        <th style="width: 111px;" class="px-1 py-2"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, itm_idx) in returnorder.items" :key="'item-' + itm_idx">
                                                        <td class="p-1">
                                                            <ValidationProvider :vid="'items.' + itm_idx + '.CardSeriesID'" name="SKU" rules="" v-slot="{ errors }">
                                                                <input type="text" class="form-control" v-model="item.ProdID" :class="{'border-danger':errors[0]}" readonly>
                                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                            </ValidationProvider>
                                                        </td>
                                                        <td class="p-1">
                                                            <div v-if="item.product.images && item.product.images.length > 0">
                                                                <div :id="`product-image-${item.ProdID}-${itm_idx}`"
                                                                     style="width: 38px; height: 38px; background-repeat: no-repeat; background-position: center; background-size: cover;"
                                                                     :style="{ 'background-image': 'url(' + item.product.images[0].urls['small'] + ') '}"></div>
                                                                <b-popover :target="`product-image-${item.ProdID}-${itm_idx}`" triggers="hover">
                                                                    <img :src="item.product.images[0].urls['medium']" :alt="item.ProdID" style="width: 100%;">
                                                                </b-popover>
                                                            </div>
                                                            <div v-else style="width: 38px; height: 38px; background-color: #ccc;"></div>
                                                        </td>
                                                        <td class="p-1 position-relative">
                                                            <ValidationProvider :vid="'items.' + itm_idx + '.ProdName'" name="Benämning" rules="" v-slot="{ errors }">
                                                                <input type="text" class="form-control" v-model="item.ProdName" :class="{'border-danger':errors[0]}" readonly>
                                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                            </ValidationProvider>
                                                            <div style="position: absolute; right: 12px; top: 13px;">
                                                                <div v-if="!(item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00') && !item.IsReserved && item.product.isPhasedOut === 1"
                                                                     class="badge badge-danger"
                                                                >HAR UTGÅTT</div>
                                                                <div v-else-if="!(item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00') && !item.IsReserved && item.product.isOutOfStock"
                                                                     class="badge badge-danger"
                                                                >TILLF. SLUT</div>
                                                            </div>
                                                        </td>
                                                        <td class="p-1">
                                                            <div class="d-flex">
                                                                <i :id="`product-stock-${item.ProdID}-${itm_idx}`" class="icon icon-info22 mr-2"></i>
                                                                <i
                                                                    :id="`product-reserved-${item.ProdID}-${itm_idx}`"
                                                                    class="icon"
                                                                    :class="[
                                                                        (
                                                                            (item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00')
                                                                            ? 'icon-check text-success'
                                                                            : ((item.product.sendByExternalSupplier || item.IsReserved) ? 'icon-check text-primary' : 'icon-cross text-danger')
                                                                        )
                                                                    ]"
                                                                ></i>
                                                            </div>
                                                            <b-popover :target="`product-stock-${item.ProdID}-${itm_idx}`" triggers="hover" custom-class="wide-popover">
                                                                <div v-if="item.product.isStruct" class="badge badge-info mb-1">STRUKTURARTIKEL</div>
                                                                <div v-if="item.product.isPhasedOut === 1" class="badge badge-danger mb-1">HAR UTGÅTT</div>
                                                                <div v-else-if="item.product.isOutOfStock" class="badge badge-danger mb-1">TILLF. SLUT</div>
                                                                <div v-if="item.product.sendByExternalSupplier">
                                                                    <div>
                                                                        <span class="font-weight-semibold">Skickad till extern leverantör:</span>
                                                                        <span v-if="item.ExportedTS" class="ml-1 badge badge-success">{{ formatDateTime(item.ExportedTS) }}</span>
                                                                        <span v-else class="ml-1 badge badge-danger">Nej</span>
                                                                    </div>
                                                                    <div v-if="item.sub_products && Array.isArray(item.sub_products)" class="mt-2">
                                                                        <div
                                                                            v-for="(sub_prod, sub_idx) in item.sub_products"
                                                                            :key="'item-' + itm_idx + '-sub-' + sub_idx"
                                                                            style="white-space: nowrap; margin-bottom: 10px;"
                                                                        >
                                                                            <div class="font-weight-semibold">Titel: {{ sub_prod.prod_name }}</div>
                                                                            <div v-if="sub_prod.type === 'pocket_pack'">ISBN: {{ sub_prod.isbn }}</div>
                                                                            <div v-if="sub_prod.type === 'magazine_subscription'">Antal nummer: {{ sub_prod.no_of_issues }}</div>
                                                                            <div v-if="sub_prod.type === 'magazine_subscription'">Förlag: {{ sub_prod.source }}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-else>
                                                                    <div>Lagersaldo: <span :class="{ 'text-success': item.product.Stock_today > 0, 'text-danger': item.product.Stock_today <= 0 }">{{ item.product.Stock_today }}</span></div>
                                                                    <div>Disponibelt saldo: <span :class="{ 'text-success': item.product.Stock_future > 0, 'text-danger': item.product.Stock_future <= 0 }">{{ item.product.Stock_future }}</span></div>
                                                                    <div v-if="item.product.purchase_items">
                                                                        <hr>
                                                                        Kommande inköp:
                                                                        <div
                                                                            v-for="(purchaseItem, pi_index) in item.product.purchase_items"
                                                                            :key="'pi-' + pi_index"
                                                                        >
                                                                            {{ purchaseItem.EffectiveTS ? purchaseItem.EffectiveTS.substring(0, 10) : 'Antal' }}: {{ purchaseItem.Antal }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </b-popover>
                                                            <b-popover :target="`product-reserved-${item.ProdID}-${itm_idx}`" triggers="hover" custom-class="wide-popover">
                                                                <div v-if="item.product.sendByExternalSupplier">
                                                                    <span class="font-weight-semibold">Skickad till extern leverantör:</span>
                                                                    <span v-if="item.ExportedTS" class="ml-1 badge badge-success">{{ formatDateTime(item.ExportedTS) }}</span>
                                                                    <span v-else class="ml-1 badge badge-danger">Nej</span>
                                                                </div>
                                                                <div v-else>
                                                                    <div v-if="item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00'">Levererad: {{ formatDateTime(item.DeliveredTS) }}</div>
                                                                    <div v-else-if="item.IsReserved">Reserverad</div>
                                                                    <div v-else>{{ 'Ej reserverad' + (item.product.ProductCodeTypeID > 0 ? '' : ': kan ej levereras') }}</div>
                                                                </div>
                                                            </b-popover>
                                                        </td>
                                                        <td class="p-1">
                                                            <div class="d-flex">
                                                                <button v-if="item.product.ProductCodeTypeID > 0" type="button" class="btn btn-light mr-1" @click="showCodes(item)"><i class="icon-ticket"></i></button>
                                                                <router-link :to="{ name: 'products.edit', params: { id: item.ProdID } }" target="_blank" class="btn btn-light mr-1"><i class="icon-gift"></i></router-link>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-danger"
                                                                    @click="deleteOrderItem(itm_idx)"
                                                                    :disabled="!!(returnorder.StatusID >= 300 || (item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00') || item.ExportedTS)"
                                                                >
                                                                    <i class="icon-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div v-if="returnorder.StatusID < 300 && returnorder.items.length < 3" class="p-1">
                                            <product-filter
                                                placeholder="Lägg till produkt..."
                                                @option:selected="addOrderItem"
                                                v-model="add_product"
                                                show-status
                                            ></product-filter>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="d-flex justify-content-between">
                                        <limitless-button
                                            v-show="returnorder.StatusID > 0"
                                            ref="btnPrintLabel"
                                            btn-class="btn-warning"
                                            type="button"
                                            @click="btnPrintLabel(dirty)"
                                            icon="icon-printer"
                                        >Skriv ut FRAKTSEDEL</limitless-button>
                                        <limitless-button
                                            v-show="returnorder.StatusID > 0"
                                            ref="btnPrintLetter"
                                            btn-class="btn-warning ml-3"
                                            type="button"
                                            @click="btnPrintLetter(dirty)"
                                            icon="icon-printer"
                                        >Skriv ut BREVETIKETT</limitless-button>
<!--                                        <limitless-button-->
<!--                                            v-show="returnorder.StatusID > 0"-->
<!--                                            ref="btnPrintPtouch"-->
<!--                                            btn-class="btn-warning ml-3"-->
<!--                                            type="button"-->
<!--                                            @click="btnPrintPtoch(dirty)"-->
<!--                                            icon="icon-printer"-->
<!--                                        >Skriv ut P-TOUCH</limitless-button>-->
                                        <limitless-button
                                            v-show="returnorder.StatusID > 0"
                                            ref="btnShowPrintReturn"
                                            btn-class="btn-warning ml-3"
                                            type="button"
                                            @click="btnShowModalCreateReturn(dirty)"
                                            icon="icon-printer"
                                        >Skapa RETURSEDEL</limitless-button>
                                        <limitless-button
                                            ref="btnsavereturnorder"
                                            type="button"
                                            @click="saveReturnOrder"
                                            :busy="busy_saving"
                                            icon="icon-floppy-disk"
                                            class="ml-auto"
                                        >Spara</limitless-button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
                    <div v-if="returnorder && returnorder.ReturnOrderID > 0">
                        <div class="btn-group position-static">
                            <button type="button" class="btn btn-secondary btn-labeled btn-labeled-left dropdown-toggle mr-2" data-toggle="dropdown" aria-expanded="false">
                                <b><i class="icon-mention"></i></b> SKICKA MAIL
                            </button>
                            <div class="dropdown-menu dropdown-menu-left">
                                <button type="button" class="dropdown-item" @click="showModalMail('delivery_notice')" :disabled="!has_packages_en_route">LEVERANSBESKED</button>
                                <button type="button" class="dropdown-item" @click="showModalMail('ready_for_pickup')" :disabled="!has_packages_to_collect">FINNS ATT HÄMTA</button>
                                <button type="button" class="dropdown-item" @click="showModalMail('return_label')">RETURFRAKTSEDEL</button>
                            </div>
                        </div>
                        <div class="btn-group position-static">
                            <button type="button" class="btn btn-secondary btn-labeled btn-labeled-left dropdown-toggle mr-2" data-toggle="dropdown" aria-expanded="false">
                                <b><i class="icon-mobile"></i></b> SKICKA SMS
                            </button>
                            <div class="dropdown-menu dropdown-menu-left">
                                <!--                            <button type="button" class="dropdown-item" @click="showModalMail('confirmation')">BEKRÄFTELSE</button>-->
                                <button type="button" class="dropdown-item" @click="showModalSms('delivery_notice')" :disabled="!has_packages_en_route">LEVERANSBESKED</button>
                                <button type="button" class="dropdown-item" @click="showModalSms('ready_for_pickup')" :disabled="!has_packages_to_collect">FINNS ATT HÄMTA</button>
                                <button type="button" class="dropdown-item" @click="showModalSms('message')">MEDDELANDE</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="returnorder.ReturnOrderID > 0" class="col-lg-4">
                    <div class="card">
                        <div class="card-header header-elements-inline bg-light">
                            <a data-toggle="collapse" class="text-body" href="#collapse-parcels">
                                <h5 class="card-title"><i class="icon-truck mr-2"></i>Utskrivna fraktsedlar</h5>
                            </a>
                        </div>
                        <div id="collapse-parcels" class="collapse">
                            <div v-if="busy_loading_parcels" class="card-body">
                                <i class="icon-spinner2 spinner"></i>
                            </div>
                            <div v-else-if="parcels && ((parcels.unifaun && parcels.unifaun.length > 0) || (parcels.ntaps && parcels.ntaps.length > 0))">
                                <table class="table table-xs">
                                    <tbody>
                                        <template v-if="parcels.unifaun && parcels.unifaun.length > 0">
                                            <tr v-for="(up, up_index ) in parcels.unifaun" :key="'up-' + up_index">
                                                <td :class="{ 'text-line-through': up.isHidden }"><nobr>{{ formatDateTime(up.printdate).substring(0, 16) }}</nobr></td>
                                                <td :class="{ 'text-line-through': up.isHidden }">
                                                    <div>{{ up.kollino }}</div>
                                                    <div>
                                                        <a :href="'https://www.postnord.se/vara-verktyg/spara-brev-paket-och-pall?shipmentId=' + up.kollino" :id="'link-' + up.kollino">[PT] {{ up.status ? up.status.StatusDesc : 'Status saknas' }}</a>
                                                        <b-popover key="warning-out-of-stock" :target="'link-' + up.kollino" triggers="hover focus" placement="bottom" v-if="up.pt_datedelivered || up.pt_acceptor">
                                                            <div v-if="up.pt_datedelivered">Levererat: {{ formatDateTime(up.pt_datedelivered) }}</div>
                                                            <div v-if="up.pt_acceptor">Mottaget av: {{ up.pt_acceptor }}</div>
                                                        </b-popover>
                                                    </div>
                                                </td>
                                                <td>
                                                    <a v-if="!up.isHidden" class="badge badge-warning" :href="old_system_url + '/showPDF_PostReklamation.php?CardNo=' + returnorder.CardNo + '&KolliNo=' + up.kollino">REKL.</a>
                                                    <a v-if="!up.isHidden" class="badge badge-warning cursor-pointer" @click.prevent="tearShippingLabel(up.kollino)">RIV</a>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-if="parcels.ntaps && parcels.ntaps.length > 0">
                                            <tr v-for="(np, np_index ) in parcels.ntaps" :key="'np-' + np_index">
                                                <td :class="{ 'text-line-through': !!(np.shipment.deleted_at) }">
                                                    <nobr>{{ formatDateTime(np.shipment.created_at).substring(0, 16) }}</nobr>
                                                    <div class="text-muted">{{ np.shipment.service_type }}</div>
                                                </td>
                                                <td :class="{ 'text-line-through': !!(np.shipment.deleted_at) }">
                                                    <div>{{ np.parcel_number }}<span v-if="np.shipment.service_type.includes('RETURN')"><i class="icon-rotate-ccw3 text-danger"></i></span></div>
                                                    <div>
                                                        <a v-if="np.shipment.service_type.indexOf('UPS-') === 0" :href="'https://www.ups.com/track?loc=en_SE&tracknum=' + np.parcel_number + '&requester=ST/trackdetails'" :id="'link-' + np.parcel_number" target="_blank">[PT] {{ np.status ? np.status.StatusDesc : 'Status saknas' }}</a>
                                                        <a v-else :href="'https://www.postnord.se/vara-verktyg/spara-brev-paket-och-pall?shipmentId=' + np.parcel_number" :id="'link-' + np.parcel_number" target="_blank">[PT] {{ np.status ? np.status.StatusDesc : 'Status saknas' }}</a>
                                                        <b-popover key="warning-out-of-stock" :target="'link-' + np.parcel_number" triggers="hover focus" placement="bottom" v-if="np.delivered_at || np.acceptor">
                                                            <div v-if="np.delivered_at">Levererat: {{ formatDateTime(np.delivered_at) }}</div>
                                                            <div v-if="np.acceptor">Mottaget av: {{ np.acceptor }}</div>
                                                        </b-popover>
                                                    </div>
                                                </td>
                                                <td>
                                                    <a v-if="np.meta && np.meta.label_printout" type="button" class="badge badge-info" @click.prevent="showShippingLabel(np)">Label</a>
                                                    <router-link v-if="!np.shipment.deleted_at" class="badge badge-warning" :to="{ name: 'shipping.complaints.create', params: { parcelId: np.id } }">REKL.</router-link>
                                                    <a v-if="!np.shipment.deleted_at" class="badge badge-warning cursor-pointer" @click.prevent="tearShippingLabel(np.parcel_number)">RIV</a>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="card-body">
                                <i>Inga fraktsedlar</i>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header header-elements-inline bg-light">
                            <h5 class="card-title"><i class="icon-list mr-2"></i>Logg</h5>
                            <div class="header-elements">
                                <button type="button" class="btn btn-light" @click="show_full_log = !show_full_log">{{ (show_full_log ? 'Dölj' : 'Visa') }} automatiska loggar</button>
                            </div>
                        </div>
                        <div class="overflow-auto flex-grow-1">
                            <div
                                v-for="(log, l_index) in filteredLogs"
                                :key="'l-' + l_index"
                                class="border-bottom p-2"
                            >
                                <div>
                                    <span class="font-weight-semibold">{{ (log.user ? log.user.FullName : log.CommentBy) }}</span>
                                    <span class="text-muted">
                                        <span class="mx-1">&bull;</span>
                                        {{ formatDateTime(log.CommentTS) }}
                                    </span>
                                    <template v-if="log.data">
                                        <span v-if="log.data.delivered_ts || log.data.opened_ts || log.data.clicked_ts || log.data.bounced_ts" class="mx-1 text-muted">&bull;</span>
                                        <span v-if="log.data.delivered_ts">
                                            <i :id="'delivered_ts-' + log.ReturnOrderCommentID" class="icon-mail5 text-success"></i>
                                            <b-popover key="warning-delivered_ts" :target="'delivered_ts-' + log.ReturnOrderCommentID" triggers="hover focus" placement="bottom">
                                                Levererat: {{ formatDateTime(log.data.delivered_ts) }}
                                            </b-popover>
                                        </span>
                                        <span v-if="log.data.opened_ts">
                                            <i :id="'opened_ts-' + log.ReturnOrderCommentID" class="icon-mail-read text-success"></i>
                                            <b-popover key="warning-opened_ts" :target="'opened_ts-' + log.ReturnOrderCommentID" triggers="hover focus" placement="bottom">
                                                Öppnat: {{ formatDateTime(log.data.opened_ts) }}
                                            </b-popover>
                                        </span>
                                        <span v-if="log.data.clicked_ts">
                                            <i :id="'clicked_ts-' + log.ReturnOrderCommentID" class="icon-touch text-success"></i>
                                            <b-popover key="warning-clicked_ts" :target="'clicked_ts-' + log.ReturnOrderCommentID" triggers="hover focus" placement="bottom">
                                                Klickat: {{ formatDateTime(log.data.clicked_ts) }}
                                            </b-popover>
                                        </span>
                                        <span v-if="log.data.bounced_ts">
                                            <i :id="'bounced_ts-' + log.ReturnOrderCommentID" class="icon-cross2 text-danger"></i>
                                            <b-popover key="warning-bounced_ts" :target="'bounced_ts-' + log.ReturnOrderCommentID" triggers="hover focus" placement="bottom">
                                                <div>Bounced: {{ formatDateTime(log.data.bounced_ts) }}</div>
                                                <div>{{ log.data.bounced_msg }}</div>
                                            </b-popover>
                                        </span>
                                    </template>
                                </div>
                                <div>
                                    {{ log.CommentText }}
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <ValidationObserver ref="logform">
                                <textarea-with-validation
                                    vid="comment"
                                    rules="required"
                                    label="Kommentarer"
                                    v-model="comment"
                                    :disabled="busy_saving_log"
                                    placeholder="Skriv i loggen..."
                                ></textarea-with-validation>
                            </ValidationObserver>
                            <div class="text-right mt-2">
                                <limitless-button ref="btnsavecomment" @click="saveComment" icon="icon-pencil3" :busy="busy_saving_log">SKRIV</limitless-button>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header header-elements-inline bg-light">
                            <a data-toggle="collapse" class="text-body" href="#collapse-supplier-complaints">
                                <h5 class="card-title">
                                    <div style="display: inline-block; height: 16px; width: 16px; margin-bottom: -2px;" class="mr-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13 20H18V22H6V20H11V13.97C8.19 13.7 6 11.34 6 8.46C6 8.15 6.03 7.85 6.08 7.55L7 2H13.54L12.33 4.41L11.79 5.5H13.79L12.33 8.41L11.79 9.5H14L13 12.75L15.67 9.09L16.46 8H14.21L15.67 5.09L16.21 4H14.21L15.21 2H17L17.93 7.55C18 7.85 18 8.15 18 8.46C18 11.34 15.81 13.7 13 13.97V20Z" /></svg>
                                    </div>
                                    Reklamationer mot leverantör
                                </h5>
                            </a>
                            <div class="header-elements" v-if="prodorder && prodorder.items.length > 0">
                                <button type="button" class="btn btn-light" @click="showModalComplaint">Skapa reklamation</button>
                            </div>
                        </div>
                        <div id="collapse-supplier-complaints" class="collapse">
                            <div v-if="busy_loading_supplier_complaints" class="card-body">
                                <i class="icon-spinner2 spinner"></i>
                            </div>
                            <div v-else-if="supplier_complaints.length > 0">
                                <table class="table table-xs">
                                    <tbody>
                                        <tr v-for="(sc, sc_index ) in supplier_complaints" :key="'sc-' + sc_index">
                                            <td><router-link :to="{ name: 'complaints.edit', params: { id: sc.id } }">#{{ sc.id }}</router-link></td>
                                            <td>{{ formatDateTime(sc.created_at) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="card-body">
                                <i>Inga reklamationer</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <activity-notification v-if="returnorder && returnorder.ReturnOrderID > 0" :channel="'return-order-' + returnorder.ReturnOrderID"></activity-notification>

            <b-modal title="Produktkoder" id="modal-show-codes" ok-title="Stäng" ok-variant="light" ok-only>
                <div v-if="codes_item">
                    <div v-for="code in codes_item.codes" :key="'code-' + code.code">
                        {{ code.code }}<span v-if="code.expire_date"> - Giltig till {{ code.expire_date }}</span>
                    </div>
                </div>
            </b-modal>

            <b-modal
                id="modal_upload_files"
                title="Ladda upp bilder / video / filer"
                key="modal_upload_files"
                ok-only
                scrollable
                ok-title="Stäng"
                ok-variant="light"
                size="xl"
                @hide="closeUploadModal"
            >
                <multiple-file-uploader
                    :url="'/vue/returnorders/' + id + '/files/upload'"
                    :extensions="'jpg,jpeg,png,pdf,mp4,m4v,mov,doc,docx,xls,xlsx,txt'"
                    :accept="'image/png,image/jpeg,application/pdf,video/mp4,video/x-m4v,video/quicktime' +
                    'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
                    'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain'"
                    @busy="busy_uploading_files = $event"
                    multiple
                />
            </b-modal>

            <b-modal
                id="modal_sms_form"
                title="Skicka SMS"
                key="modal_sms_form"
                ok-title="Skicka"
                cancel-title="Stäng"
                cancel-variant="light"
                size="sm"
                @ok="sendSms"
                :ok-disabled="!show_send_button_sms"
            >
                <div v-if="returnorder">
                    <ValidationObserver ref="smsform">
                        <form @submit.prevent="sendSms">
                            <input-with-validation
                                vid="from"
                                rules="required"
                                label="Från"
                                v-model="sms.from"
                                disabled
                                placeholder="Från"
                            ></input-with-validation>
                            <input-with-validation
                                vid="to"
                                rules="required"
                                label="Till"
                                v-model="sms.to"
                                disabled
                                placeholder="Mobiltelefonnummer"
                            ></input-with-validation>
                            <textarea-with-validation
                                vid="message"
                                rules="required"
                                label="Meddelande"
                                v-model="sms.message"
                                :disabled="busy_sending_sms"
                                placeholder="Skriv ett meddelande..."
                                :rows="4"
                            ></textarea-with-validation>
                        </form>
                    </ValidationObserver>
                    <div style="font-size: 12px;" class="text-muted">
                        <div>Antal SMS: {{ sms_count.messages }}</div>
                        <div>Encoding: {{ sms_count.encoding }}</div>
                        <div>Antal tecken kvar: {{ sms_count.remaining }}</div>
                    </div>
                </div>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-light" @click="cancel">Stäng</button>
                    <limitless-button ref="btnsendsms" icon="icon-paperplane" @click="ok" :disabled="!sms.to">Skicka</limitless-button>
                </template>
            </b-modal>

            <b-modal
                id="modal_mail_preview"
                :title="'Skicka ' + mail_type_human"
                key="modal_mail_preview"
                ok-title="Skicka"
                cancel-title="Stäng"
                cancel-variant="light"
                size="xl"
                @ok="sendMail"
                :ok-disabled="!show_send_button_email"
            >
                <div v-if="returnorder">
                    <ValidationObserver ref="mailform">
                        <div
                            v-if="(mail_type === 'delivery_notice' || mail_type === 'ready_for_pickup')
                             && (this.parcels.unifaun.filter((row) => !row.isHidden && row.kollino).length <= 0 && this.parcels.ntaps.filter((row) => !row.deleted_at).length <= 0)"
                            class="alert alert-warning"
                        >
                            Det finns inga kollinummer kopplade till denna order, vill du verkligen skicka leveransbesked?
                        </div>
                        <div
                            v-else-if="mail_type === 'return_label' && return_parcels.length <= 0"
                            class="alert alert-warning"
                        >
                            Det finns inga returfraktsedlar skapade på denna order, skapa en returfraktsedel först!
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" style="max-width: 150px;">Till:<span class="text-danger">*</span></label>
                            <div class="col" style="max-width: 500px;">
                                <input type="text" :value="returnorder.Email" class="form-control" readonly>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" style="max-width: 150px;">Meddelande:</label>
                            <div class="col" style="max-width: 500px;">
                                <ValidationProvider vid="message" name="Meddelande" v-slot="{ errors }">
                                    <elastic-textarea type="text" v-model="mail.message" class="form-control" :class="{'border-danger':errors[0]}" :strip-tags="false"></elastic-textarea>
                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div v-if="mail_type === 'return_label'" class="form-group row">
                            <label class="col col-form-label" style="max-width: 150px;">Fraktsedel:<span class="text-danger">*</span></label>
                            <div class="col" style="max-width: 500px;">
                                <ValidationProvider vid="message" name="Meddelande" v-slot="{ errors }">
                                    <vue-select
                                        v-model="mail.return_parcel"
                                        :options="return_parcels"
                                        :clearable="false"
                                        :reduce="(opt) => opt.id"
                                        label="parcel_number"
                                        :get-option-label="(opt) => opt.parcel_number + ' (' + formatDateTime(opt.created_at).substring(0, 16) + ')'"
                                    ></vue-select>
                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                    </ValidationObserver>
                    <hr>
                    <iframe
                        v-if="mail_preview_url"
                        :src="mail_preview_url"
                        style="border: 0; width: 100%;"
                        :style="{ height: (mail_type=== 'message' ? 1000 : (mail.message ? 2000 : 1700)) + 'px' }"
                    ></iframe>
                </div>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-light" @click="cancel">Stäng</button>
                    <limitless-button ref="btnsendmail" icon="icon-paperplane" @click="ok" :disabled="!returnorder.Email">Skicka</limitless-button>
                </template>
            </b-modal>

            <b-modal
                id="modal_create_complaint"
                title="Skapa reklamation till leverantören"
                key="modal_create_complaint"
                ok-title="Skapa"
                cancel-title="Avbryt"
                cancel-variant="light"
                @ok="createComplaint"
            >
                <div v-if="returnorder">
                    <div v-if="returnorder.ResendReasonBy !== 5" class="alert alert-warning alert-styled-left">
                        Det är satt att felet berodde på <span class="font-weight-bold">{{ resend_reason_by_label }}</span>, vill du ändå skapa en reklamation mot leverantören?
                    </div>
                    <ValidationObserver ref="complaintform">
                        <form @submit.prevent="createComplaint">
                            <ValidationProvider
                                vid="prod_id"
                                name="Produkt"
                                rules="required"
                            >
                                <div class="form-group">
                                    <label>Vilken produkt ska reklameras?</label>
                                    <div
                                        v-for="(prod, p_index) in this.prodorder.items"
                                        class="custom-control custom-radio mb-2"
                                        :key="'rklp-' + prod.ProdOrderItemID + '-' + p_index"
                                    >
                                        <input type="radio" class="custom-control-input" name="prod_id" :id="'rklp-' + prod.ProdOrderItemID + '-' + p_index" v-model="complaint.prod_id" :value="prod.product.ProdID">
                                        <label class="custom-control-label" :for="'rklp-' + prod.ProdOrderItemID + '-' + p_index">#{{ prod.product.ProdID }} - {{ prod.product.ProdName}}</label>
                                    </div>
                                </div>
                            </ValidationProvider>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="cmp-copy-images" v-model="complaint.copy_images">
                                    <label class="custom-control-label" for="cmp-copy-images">Kopiera bilder</label>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="cmp-copy-description" v-model="complaint.copy_description">
                                    <label class="custom-control-label" for="cmp-copy-description">Kopiera beskrivning av fel/skada</label>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="cmp-copy-internal-comment" v-model="complaint.copy_internal_comment">
                                    <label class="custom-control-label" for="cmp-copy-internal-comment">Kopiera intern kommentar</label>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-light" @click="cancel">Avbryt</button>
                    <limitless-button ref="btncreatecomplaint" icon="icon-floppy-disk" @click="ok">Skapa</limitless-button>
                </template>
            </b-modal>

            <b-modal
                id="modal_show_shipping_label"
                title="Fraktsedel"
                key="modal_show_shipping_label"
                ok-only
                scrollable
                ok-title="Stäng"
                ok-variant="light"
                size="xl"
                @hide="show_shipping_label = null;"
            >
                <div v-if="show_shipping_label && show_shipping_label.meta && show_shipping_label.meta.label_printout && show_shipping_label.meta.label_printout.length > 0">
                    <div
                        v-for="(label, l_index) in show_shipping_label.meta.label_printout"
                        :key="'label-' + l_index"
                    >
                        <div v-if="label.type === 'LABEL'">
                            <iframe :src="'data:application/pdf;base64,' + label.data" style="width: 100%; height: 500px;"></iframe>
                        </div>
                        <div v-if="label.type === 'QRCODE'">
                            <img :src="'data:image/png;base64,' + label.data" alt="QR Code">
                        </div>
                    </div>
                </div>
                <div v-else><i>Ingen digital fraktsedel att visa</i></div>
            </b-modal>

            <b-modal
                id="modal_create_return_label"
                title="Skapa returfraktsedel QR-kod+PDF"
                key="modal_create_return_label"
                ok-title="Skapa"
                cancel-title="Avbryt"
                cancel-variant="light"
                @ok="createReturnLabel"
            >
                <div class="form-group">
                    <label>Returnera till</label>
                    <vue-select
                        v-model="return_label.to"
                        :options="return_label_to"
                        :clearable="false"
                        :reduce="(opt) => opt.id"
                    ></vue-select>
                </div>
                <div class="form-group">
                    <label>Instruktion till mottagaren ({{ return_label_to.find((opt) => opt.id === return_label.to).label }})</label>
                    <textarea class="form-control" v-model="return_label.consignee_instructions"></textarea>
                </div>
                <div class="form-group">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="chk-send_to_customer" v-model="return_label.send_to_customer">
                        <label class="custom-control-label" for="chk-send_to_customer">Skicka QR-kod och PDF till kund</label>
                    </div>
                </div>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-light" @click="cancel">Avbryt</button>
                    <limitless-button ref="btncreatecomplaint" icon="icon-floppy-disk" @click="ok" :busy="bust_creating_return">Skapa</limitless-button>
                </template>
            </b-modal>
        </div> <!-- /content -->
        <div v-else-if="not_found" class="content">
            <i v-if="!(id > 0 || prod_order_id > 0)">Reklamation kan inte skapas utan att ange en order</i>
            <i v-else>Reklamationen hittades inte</i>
        </div>
        <div v-else class="content">
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import TextareaWithValidation from '@components/Form/TextareaWithValidation.vue';
import { mapState } from 'pinia';
import { formatDateTime, getWeek } from '@services/Helpers';
import MultipleFileUploader from '@components/MultipleFileUploader.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import { debounce } from 'lodash';
import Cache from '@services/Cache';
import ElasticTextarea from '@components/ElasticTextarea.vue';
import { count } from 'sms-length';
import ActivityNotification from '@components/User/ActivityNotification.vue';
import { useAuthStore } from '@services/pinia/AuthStore';
import VueSelect from '@components/Wrappers/VueSelect.vue';
import BackendRepository from '@services/repositories/BackendRepository';
import ProductFilter from '@components/Filters/ProductFilter.vue';

export default {
    name: 'ReturnOrderEdit',
    components: {
        ProductFilter,
        VueSelect,
        ActivityNotification,
        ElasticTextarea,
        VDatePicker,
        InputWithValidation,
        SelectWithValidation,
        MultipleFileUploader,
        TextareaWithValidation,
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
    },
    data: () => ({
        not_found: false,
        initialized: false,
        busy_loading: true,
        busy_loading_files: true,
        busy_uploading_files: false,
        busy_saving: false,
        busy_sending_sms: false,
        busy_loading_parcels: false,
        busy_loading_supplier_complaints: false,
        busy_loading_logs: false,
        busy_saving_log: false,
        show_full_log: true,
        prodorder: null,
        returnorder: null,
        delivery_info: '',
        comment: '',
        images: [],
        supplier_complaints: [],
        parcels: null,
        logs: [],
        select_products: [],
        codes_item: [],
        is_dirty: false,
        add_product: null,
        prod_order_id: null,
        select_resend_reasons: [],
        select_resend_reason_by: [],
        select_request_return: [],
        select_door_types: [],
        show_send_button_sms: false,
        show_send_button_email: false,
        mail_type: null,
        mail_preview_url: '',
        statuses: [],
        complaint: {
            prod_id: null,
            copy_images: true,
            copy_description: true,
            copy_internal_comment: true,
        },
        mail: {
            message: '',
            return_parcel: null,
        },
        sms: {
            from: '',
            to: '',
            message: '',
        },
        show_shipping_label: null,
        return_label_to: [
            {
                id: 'default',
                label: 'Nova Lagret',
            },
            {
                id: 'hk',
                label: 'HK',
            },
        ],
        return_label: {
            type: 'return_order',
            to: 'default',
            send_to_customer: true,
            consignee_instructions: '',
        },
        bust_creating_return: false,
        service_point: false,
    }),
    mounted() {
        this.getStatuses();
        this.getSelectOptions();
        this.init();
    },
    watch: {
        id() {
            this.images = [];
            this.logs = [];
            this.parcels = null;
            this.supplier_complaints = [];
            this.init();
        },
        'returnorder.Zip': debounce(function returnorderZip(val) {
            this.checkPostalCode(val);
        }, 1000),
        'returnorder.WantedDeliveryDate': debounce(function returnorderWantedDeliveryDate() {
            if (this.returnorder.Zip) {
                this.checkPostalCode(this.returnorder.Zip);
            }
        }, 1000),
    },
    methods: {
        formatDateTime,
        init() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const prodOrderID = urlParams.get('prod_order_id');
            this.prod_order_id = prodOrderID;
            this.getReturnOrder(prodOrderID);
            if (this.id > 0) {
                this.getImages();
                this.getLogs();
                this.getParcels();
                this.getSupplierComplaints();
            }
        },
        getStatuses() {
            BackendRepository.getStatuses().then((res) => {
                this.statuses = res;
            });
        },
        getReturnOrder(prodOrderID) {
            if (!(this.id > 0 || prodOrderID > 0)) {
                this.not_found = true;
                this.initialized = true;
                this.busy_loading = false;
                return;
            }
            this.busy_loading = true;
            apiClient.get('/vue/returnorders/' + this.id + (prodOrderID ? '?prod_order_id=' + prodOrderID : ''))
                .then((response) => {
                    this.returnorder = response.data.returnorder;
                    this.prodorder = response.data.prodorder;
                    this.checkPostalCode(response.data.returnorder.Zip);
                    this.service_point = response.data.returnorder.service_point;
                    if (response.data.returnorder.Email) {
                        this.show_send_button_email = true;
                    } else {
                        this.show_send_button_email = false;
                    }
                    if (response.data.returnorder.Phone) {
                        this.show_send_button_sms = true;
                    } else {
                        this.show_send_button_sms = false;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy_loading = false;
                });
        },
        async saveReturnOrder() {
            const isValid = await this.$refs.returnorderform.validate();
            if (isValid) {
                if (this.returnorder.ReturnOrderID > 0 && this.returnorder.StatusID === 0) {
                    let doSetStatus = false;
                    await this.$swal({
                        text: 'Vill du sätta status omleverans/klar för leverans?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Ja',
                        cancelButtonText: 'Nej',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            doSetStatus = true;
                        }
                    });
                    if (doSetStatus) {
                        this.returnorder.StatusID = 80;
                    }
                }
                this.busy_saving = true;
                await apiClient.post('/vue/returnorders/' + this.id, { prod_order_id: this.prod_order_id, ...this.returnorder })
                    .then((response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.returnorder.ReturnOrderID, 10)) {
                            window.location.href = '/returnorders/' + response.data.returnorder.ReturnOrderID;
                        }
                        this.returnorder = response.data.returnorder;
                        this.prodorder = response.data.prodorder;
                        this.service_point = response.data.returnorder.service_point;
                        this.$refs.btnsavereturnorder.triggerSaved();
                        this.$refs.returnorderform.reset();
                        if (response.data.returnorder.Email) {
                            this.show_send_button_email = true;
                        } else {
                            this.show_send_button_email = false;
                        }
                        if (response.data.returnorder.Phone) {
                            this.show_send_button_sms = true;
                        } else {
                            this.show_send_button_sms = false;
                        }
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.returnorderform.setErrors(parsederror);
                        }
                        this.$refs.btnsavereturnorder.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            } else {
                this.$refs.btnsavereturnorder.triggerFailed();
            }
        },
        async markAsDone() {
            let doDone = false;
            await this.$swal({
                text: 'Är du säker att du vill sätta status till Avslutad?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, avsluta!',
            }).then((result) => {
                if (result.isConfirmed) {
                    doDone = true;
                }
            });
            if (doDone) {
                this.returnorder.StatusID = 900;
                await this.saveReturnOrder();
            }
        },
        getImages() {
            this.busy_loading_files = true;
            apiClient.get('/vue/returnorders/' + this.id + '/files/list')
                .then((response) => {
                    this.images = response.data;
                })
                .finally(() => {
                    this.busy_loading_files = false;
                });
        },
        async showCodes(item) {
            await apiClient.get('/vue/returnorders/items/' + item.ReturnOrderItemID + '/codes?claim=1')
                .then((response) => {
                    item.codes = [...response.data];
                    this.codes_item = item;
                });
            this.$bvModal.show('modal-show-codes');
        },
        showUploadModal() {
            this.$root.$bvModal.show('modal_upload_files');
        },
        closeUploadModal(event) {
            if (this.busy_uploading_files) {
                event.preventDefault();
            } else {
                this.getImages();
            }
        },
        showFullImage(url) {
            if (url) {
                window.open(url, '_blank');
            }
        },
        async deleteImage(filename) {
            let doDelete = false;
            await this.$swal({
                text: 'Är du säker att du vill radera bilden?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera!',
                cancelButtonText: 'Avbryt',
            }).then((result) => {
                if (result.isConfirmed) {
                    doDelete = true;
                }
            });
            if (doDelete) {
                await apiClient.delete('/vue/returnorders/' + this.id + '/files/delete/' + filename)
                    .then(() => {
                        this.getImages();
                    });
            }
        },
        getParcels() {
            this.busy_loading_parcels = true;
            apiClient.get('/vue/shipping/parcels?type=returnorder&reference=' + this.id)
                .then((response) => {
                    this.parcels = response.data;
                    if (response.data && (response.data.unifaun.length > 0 || response.data.ntaps.length > 0)) {
                        this.$nextTick(() => {
                            document.getElementById('collapse-parcels').classList.add('show');
                        });
                    }
                })
                .finally(() => {
                    this.busy_loading_parcels = false;
                });
        },
        getSupplierComplaints() {
            this.busy_loading_supplier_complaints = true;
            apiClient.get('/vue/suppliers/complaints?return_order_id=' + this.id)
                .then((response) => {
                    this.supplier_complaints = response.data.data;
                    if (response.data.data && response.data.data.length > 0) {
                        document.getElementById('collapse-supplier-complaints').classList.add('show');
                    }
                })
                .finally(() => {
                    this.busy_loading_supplier_complaints = false;
                });
        },
        getLogs() {
            this.busy_loading_logs = true;
            apiClient.get('/vue/returnorders/' + this.id + '/logs')
                .then((response) => {
                    this.logs = response.data;
                })
                .finally(() => {
                    this.busy_loading_logs = false;
                });
        },
        async saveComment() {
            const isValid = await this.$refs.logform.validate();
            if (isValid) {
                this.busy_saving_log = true;
                await apiClient.post('/vue/returnorders/' + this.id + '/logs/0', { CommentText: this.comment })
                    .then(() => {
                        this.comment = '';
                        this.$refs.btnsavecomment.triggerSaved();
                        this.$refs.logform.reset();
                    }).catch(() => {
                        this.$refs.btnsavecomment.triggerFailed();
                    }).finally(() => {
                        this.busy_saving_log = false;
                        this.getLogs();
                    });
            } else {
                this.$refs.btnsavecomment.triggerFailed();
            }
        },
        winOpen(url) {
            const myWindow = window.open(url, 'SHT_InfoPop', 'scrollbars=yes,resizable=yes,width=650,height=800,screenX=100,screenY=100');
            myWindow.focus();
        },
        checkPostalCode(code) {
            apiClient.get('/vue/delivery/postalcode?postal_code=' + code + (this.returnorder.CountryCode ? '&country_code=' + this.returnorder.CountryCode : ''))
                .then((response) => {
                    let str = '<span style="font-weight: bold; color: #990000;">';
                    if (this.returnorder.WantedDeliveryDate) {
                        const d = new Date(this.returnorder.WantedDeliveryDate);
                        if (d) {
                            d.setDate(d.getDate() - response.data.Days);
                            str += '<b>Skickas ' + d.toISOString().substring(0, 10) + '</b> ';
                        }
                    }
                    str += '(' + (response.data.Comment ? response.data.Comment : 'NORMAL') + ', ' + response.data.Days + ' dagar leverans)';
                    str += '</span>';
                    this.delivery_info = str;
                })
                .catch(() => {
                    if (this.returnorder.CountryCode !== 'SE') {
                        this.delivery_info = '<span style="font-weight: bold; color: #990000;">UTLAND Lev.tid saknas</span>';
                    } else {
                        this.delivery_info = '<span style="font-weight: bold; color: #990000;">Postnummer hittades inte</span>';
                    }
                });
        },
        searchProducts: debounce(async function searchProducts(search) {
            await apiClient.get('/vue/products', { params: { search, per_page: 8 } })
                .then((response) => {
                    this.select_products = response.data.data;
                });
        }, 300),
        addOrderItem(prod) {
            if (prod) {
                this.returnorder.items.push({
                    ReturnOrderItemID: 0,
                    ReturnOrderID: this.id,
                    ProdID: prod.ProdID,
                    ProdName: prod.ProdName,
                    product: prod,
                });
            }
            this.add_product = null;
        },
        deleteOrderItem(index) {
            this.returnorder.items.splice(index, 1);
        },
        btnPrintLabel(dirty) {
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skriver ut en fraktsedel!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            window.location.href = '/shipping/print_label?return_order_id=' + this.returnorder.ReturnOrderID;
        },
        btnPrintLetter(dirty) {
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skriver ut en brevetikett!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            // window.location.href = '/batch/list?type=return_order&print_letter=true&ids[]=' + this.returnorder.ReturnOrderID;
            window.location.href = '/shipping/print_letter?return_order_id=' + this.returnorder.ReturnOrderID;
        },
        btnPrintPtoch(dirty) {
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skriver ut en fraktsedel!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }
            window.open(this.old_system_url + '/showPDF_PtouchDeliverylabel.php?func=printbatch&ReturnOrderID=' + this.returnorder.ReturnOrderID, 'PtouchLabelWin', 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=1,width=500,height=400');
        },
        btnShowModalCreateReturn(dirty) {
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skapar en retursedel!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            if (!this.returnorder.Email || !this.returnorder.Phone) {
                this.$swal({
                    text: 'Ange kundens telefon och e-postadress innan du skapar en retursedel!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            this.$bvModal.show('modal_create_return_label');
        },
        async getSelectOptions() {
            if (Cache.get('prodorder-door-types')) {
                this.select_door_types = Cache.get('prodorder-door-types');
            } else {
                await apiClient.get('/vue/prodorders/doortypes')
                    .then((response) => {
                        this.select_door_types = response.data;
                        Cache.set('prodorder-door-types', response.data);
                    });
            }
            if (Cache.get('returnorder-request-return')) {
                this.select_request_return = Cache.get('returnorder-request-return');
            } else {
                await apiClient.get('/vue/returnorders/requestreturn')
                    .then((response) => {
                        this.select_request_return = response.data;
                        Cache.set('returnorder-request-return', response.data);
                    });
            }
            if (Cache.get('returnorder-resend-reasons-by')) {
                this.select_resend_reason_by = Cache.get('returnorder-resend-reasons-by');
            } else {
                await apiClient.get('/vue/returnorders/resendreasonsby')
                    .then((response) => {
                        this.select_resend_reason_by = response.data;
                        Cache.set('returnorder-resend-reasons-by', response.data);
                    });
            }
            if (Cache.get('returnorder-resend-reasons')) {
                this.select_resend_reasons = Cache.get('returnorder-resend-reasons');
            } else {
                await apiClient.get('/vue/returnorders/resendreasons')
                    .then((response) => {
                        this.select_resend_reasons = response.data;
                        Cache.set('returnorder-resend-reasons', response.data);
                    });
            }
        },
        showModalSms(type = 'message') {
            const { dirty } = this.$refs.returnorderform.flags;
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skickar sms!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            // eslint-disable-next-line quotes
            this.sms.message = "Ang. Kort: " + this.returnorder.CardNo + "\n\n\nKontakta oss via epost " + (this.brand?.email ? this.brand.email : "kundservice@supekort.se");
            this.sms.to = this.returnorder.Phone;
            this.sms.from = 'Supékort';
            if (this.brand) {
                this.sms.from = this.brand.name;
            }
            if (type !== 'message') {
                apiClient.get('/returnorders/' + this.id + '/smspreview/' + type)
                    .then((response) => {
                        this.sms.message = response.data;
                        this.$root.$bvModal.show('modal_sms_form');
                    });
            } else {
                this.$root.$bvModal.show('modal_sms_form');
            }
        },
        async sendSms(event) {
            event.preventDefault();
            const isValid = await this.$refs.smsform.validate();
            if (isValid) {
                this.busy_sending_sms = true;
                await apiClient.post('/vue/returnorders/' + this.id + '/send/sms', { ...this.sms })
                    .then(() => {
                        this.$refs.btnsendsms.triggerSaved();
                        this.$refs.smsform.reset();
                        this.$root.$bvModal.hide('modal_sms_form');
                        this.$swal({
                            icon: 'success',
                            title: 'Sms:et har skickats!',
                            confirmButtonText: 'OK',
                            showCancelButton: false,
                            timer: 2222,
                        });
                    }).catch(() => {
                        this.$refs.btnsendsms.triggerFailed();
                    }).finally(() => {
                        this.busy_sending_sms = false;
                        this.getLogs();
                    });
            } else {
                this.$refs.btnsendsms.triggerFailed();
            }
        },
        showModalMail(mailType) {
            const { dirty } = this.$refs.returnorderform.flags;
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skickar mail!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            if (this.return_parcels.length > 0) {
                this.mail.return_parcel = this.return_parcels[this.return_parcels.length - 1].id;
            }
            this.mail_type = mailType;
            this.updateMailPreview();
            this.$root.$bvModal.show('modal_mail_preview');
            this.mail.message = '';
        },
        async sendMail(event) {
            event.preventDefault();
            await apiClient.post('/vue/returnorders/' + this.returnorder.ReturnOrderID + '/send/' + this.mail_type, { ...this.mail })
                .then(() => {
                    const message = this.mail_type_human.charAt(0).toUpperCase() + this.mail_type_human.slice(1) + ' skickad!';
                    this.$root.$bvModal.hide('modal_mail_preview');
                    this.$swal({
                        icon: 'success',
                        title: message,
                        confirmButtonText: 'OK',
                        showCancelButton: false,
                        timer: 2222,
                    });
                }).catch((error) => {
                    this.$refs.btnsendmail.triggerFailed();
                    const parsederror = getError(error);
                    if (typeof parsederror === 'object') {
                        this.$refs.mailform.setErrors(parsederror);
                    } else {
                        let message = 'Något gick fel...';
                        if (error.response && error.response.data && error.response.data.message) {
                            message = error.response.data.message;
                        }
                        this.$swal({
                            icon: 'error',
                            title: 'Error!',
                            text: message,
                            confirmButtonText: 'OK',
                            cancelButtonText: 'Avbryt',
                        });
                    }
                });
        },
        updateMailPreview() {
            this.mail_preview_url = '/returnorders/' + this.id + '/mailpreview/' + this.mail_type + '?' + Object.keys(this.mail).filter((k) => this.mail[k]).map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(this.mail[k])}`).join('&');
        },
        showModalComplaint() {
            if (this.returnorder.product_ids[0]) {
                // eslint-disable-next-line prefer-destructuring
                this.complaint.prod_id = this.returnorder.product_ids[0];
            }
            if (!this.complaint.prod_id && this.prodorder && this.prodorder.items.length > 0) {
                this.complaint.prod_id = this.prodorder.items[0].ProdID;
            }
            this.$root.$bvModal.show('modal_create_complaint');
        },
        async createComplaint(e) {
            e.preventDefault();
            const isValid = await this.$refs.complaintform.validate();
            if (isValid) {
                this.busy_sending_sms = true;
                await apiClient.post('/vue/suppliers/complaints/0', { return_order_id: this.id, quantity: 1, ...this.complaint })
                    .then((response) => {
                        window.location.href = '/suppliers/complaints/' + response.data.id;
                    }).catch(() => {
                        this.$refs.btncreatecomplaint.triggerFailed();
                    }).finally(() => {
                        this.busy_sending_sms = false;
                        this.getSupplierComplaints();
                    });
            } else {
                this.$refs.btncreatecomplaint.triggerFailed();
            }
        },
        async changeStatus(statusId) {
            const isValid = await this.$refs.returnorderform.validate();
            if (!isValid) {
                this.$swal({
                    text: 'Du måste åtgärda valideringsfelen innan du kan ändra status.',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            const status = this.statuses.find((s) => s.id === statusId);
            if (status) {
                await this.$swal({
                    text: 'Är du säker att du vill ändra status till "' + status.name + '"?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, ändra!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.returnorder.StatusID = status.id;
                        this.saveReturnOrder();
                    }
                });
            }
        },
        tearShippingLabel(parcelNumber) {
            const inputOptions = {
                no_change: 'Ingen statusändring',
            };
            this.allowed_status_change.filter((s) => s.id <= 250).forEach((s) => {
                inputOptions[s.id] = `Ändra till status ${s.id}, ${s.name}`;
            });
            this.$swal({
                text: 'Är du säker på att du vill riva denna fraktsedel (' + parcelNumber + ')?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, riv den!',
                input: 'radio',
                inputOptions,
                inputValue: 'no_change',
            }).then((result) => {
                if (result.isConfirmed) {
                    apiClient.post('/vue/shipping/parcels/tear', { parcels: [parcelNumber] })
                        .then(() => {
                            this.getParcels();
                        });
                    if (result.value >= 0 && result.value <= 999 && result.value !== 'no_change') {
                        this.prodorder.StatusID = result.value;
                        this.saveProdOrder(false);
                    }
                }
            });
        },
        showShippingLabel(parcel) {
            this.show_shipping_label = parcel;
            this.$bvModal.show('modal_show_shipping_label');
        },
        createReturnLabel() {
            this.bust_creating_return = true;
            this.return_label.id = this.returnorder.ReturnOrderID;
            apiClient.post('/vue/shipping/create_digital_return', { ...this.return_label })
                .then((response) => {
                    this.$bvModal.hide('modal_create_return_label');
                    this.bust_creating_return = false;
                    if (Array.isArray(response.data) && response.data[0]) {
                        this.showShippingLabel(response.data[0]);
                    }
                    this.getParcels();
                });
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        send_by_mail() {
            if (this.returnorder) {
                const countByMail = this.returnorder.items.filter((item) => item.product.sendByMail).length;
                if (countByMail > 0 && countByMail === this.returnorder.items.length) {
                    return true;
                }
            }
            return false;
        },
        service_point_criteria() {
            if (this.returnorder) {
                return {
                    country_code: this.returnorder.CountryCode,
                    postal_code: this.returnorder.Zip,
                };
            }
            return {};
        },
        returnorder_name() {
            return (this.returnorder && this.returnorder.ReturnOrderID > 0 ? 'Kortnummer ' + this.returnorder.CardNo : 'Ny reklamation/retur');
        },
        returnorder_id() {
            return (this.returnorder && this.returnorder.ReturnOrderID > 0 ? this.returnorder.ReturnOrderID : '');
        },
        filteredLogs() {
            return this.logs.filter((log) => this.show_full_log || log.Type === 2);
        },
        old_system_url() {
            return window.config.app.old_system_url;
        },
        deliv_date_str() {
            if (this.returnorder && this.returnorder.WantedDeliveryDate) {
                const d = new Date(this.returnorder.WantedDeliveryDate);
                if (d) {
                    if (d.getDay() === 0 || d.getDay() === 6) {
                        return 'Vecka ' + getWeek(this.returnorder.WantedDeliveryDate);
                    }
                    return d.toLocaleString('sv', { weekday: 'long' });
                }
            }
            return '';
        },
        sms_count() {
            return count(this.sms.message);
        },
        mail_type_human() {
            if (this.mail_type === 'confirmation') {
                return 'Bekräftelse';
            }
            if (this.mail_type === 'delivery_notice') {
                return 'Leveransbesked';
            }
            if (this.mail_type === 'ready_for_pickup') {
                return 'Finns att hämta-mail';
            }
            if (this.mail_type === 'return_label') {
                return 'Returfraktsedel';
            }
            return 'message';
        },
        resend_reason_by_label() {
            if (this.returnorder) {
                const reasonBy = this.select_resend_reason_by.find((r) => r.id === this.returnorder.ResendReasonBy);
                if (reasonBy) {
                    return reasonBy.label;
                }
            }
            return '???';
        },
        return_parcels() {
            if (this.parcels && this.parcels.ntaps.length > 0) {
                return this.parcels.ntaps.filter((np) => !!(np.meta && np.meta.label_printout));
            }
            return [];
        },
        allowed_status_change() {
            const arr = [];
            if (this.returnorder && this.returnorder.ReturnOrderID > 0) {
                if (this.returnorder.StatusID < 400) {
                    arr.push(0);
                    arr.push(55);
                    arr.push(250);
                    if (this.returnorder.StatusID === 55) {
                        arr.push(60);
                        arr.push(600);
                    }
                    arr.push(610);
                }
                if (this.returnorder.StatusID !== 505) {
                    arr.push(500);
                }
                if (this.returnorder.StatusID !== 500) {
                    arr.push(505);
                }
                arr.push(590);
            }

            return this.statuses.filter((status) => status.id !== this.returnorder.StatusID && arr.includes(status.id));
        },
        has_packages_en_route() {
            return this.parcels && this.parcels.ntaps && this.parcels.ntaps.some((s) => {
                const serviceType = (s.shipment && s.shipment.service_type) ? s.shipment.service_type : '';
                return s.statuscode > 1 && s.statuscode < 6 && !serviceType.includes('RETURN');
            });
        },
        has_packages_to_collect() {
            return this.parcels && this.parcels.ntaps && this.parcels.ntaps.some((s) => {
                const serviceType = (s.shipment && s.shipment.service_type) ? s.shipment.service_type : '';
                return s.statuscode === 6 && !serviceType.includes('RETURN');
            });
        },
    },
};
</script>

<style scoped>
.image-wrapper {
    position: relative;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.image-wrapper div {
    background-color: #eeeeee;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-wrapper:after {
    content: '';
    width: 100%;
    padding-bottom: 75%;
    display: block;
}
.file-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    max-width: 100%;
    width: 100%;
}
@media only screen and (min-width: 1200px) {
    .file-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}
@media only screen and (min-width: 1440px) {
    .file-grid {
        grid-template-columns: repeat(4, 1fr);
    }
}
@media only screen and (min-width: 1700px) {
    .file-grid {
        grid-template-columns: repeat(5, 1fr);
    }
}
</style>
